<template>
  <div class="user-select">
   <span v-for="user in users" :key="user.id" >
     <img v-b-tooltip.hover.bottom
          :title="user.full_name"
          :src="user.avatar_url">
   </span>
   <span v-if="adminOrOwner || parent.full_name">
     <b-dropdown no-caret>
       <template slot="button-content">
         <span class="oi oi-plus"></span>
       </template>
       <multiselect
         v-model="users"
         :options="availableUsers"
         :multiple="true"
         :close-on-select="false"
         :clear-on-select="false"
         :hide-selected="true"
         :preserve-search="true"
         placeholder="Add User"
         label="full_name"
         track-by="id"
         @select="addUser"
         @remove="removeUser"
       >
       </multiselect>
     </b-dropdown>
   </span>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
export default {
  name: 'MultiUserSelector',
  props: {
    parent: Object,
    parentPath: String
  },
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters(['currentUser', 'availableUsers']),
    adminOrOwner () {
      if (this.parent && this.parent.hasOwnProperty('owner') && this.parent.owner_id === this.currentUser.id) {
        return true
      } else if (this.currentUser.roles.includes('admin') || this.currentUser.roles.includes('manager')) {
        return true
      } else {
        return false
      }
    }
  },
  data () {
    return {
      users: null,
      apiPath: '_users'
    }
  },
  created () {
    this.setParentUsers()
    this.apiPath = '/' + this.parentPath + this.apiPath
  },
  methods: {
    setParentUsers () {
      if (this.parent) {
        if (this.parent.covered_users) {
          this.users = this.parent.covered_users
        } else {
          this.users = this.parent.users
        }
      }
    },
    addUser (payload) {
      if (this.parent && this.parentPath) {
        var vm = this
        var params = this.postParams(payload)
        this.$http
          .post(this.apiPath, params)
          .then(function (response) {
            vm.$emit('submit-successful')
          })
      } else {
        this.$emit('user-change', payload)
      }
    },
    removeUser (payload) {
      if (this.parent && this.parentPath) {
        var vm = this
        var params = this.deleteParams(payload)
        this.$http
          .delete(this.apiPath, params)
          .then(function (response) {
            vm.$emit('delete-successful')
          })
      } else {
        this.$emit('user-change', payload)
      }
    },
    postParams (payload) {
      var params
      switch (this.parentPath) {
        case 'team':
          params = { team_user: { user_id: payload.id, team_id: this.parent.id } }
          break
        case 'board':
          params = { board_user: { user_id: payload.id, board_id: this.parent.id } }
          break
        case 'task':
          params = { task_user: { user_id: payload.id, task_id: this.parent.id } }
          break
        default:
          params = {}
      }
      return params
    },
    deleteParams (payload) {
      var params
      switch (this.parentPath) {
        case 'team':
          params = { params: { user_id: payload.id, team_id: this.parent.id } }
          break
        case 'board':
          params = { params: { user_id: payload.id, board_id: this.parent.id } }
          break
        case 'task':
          params = { params: { user_id: payload.id, task_id: this.parent.id } }
          break
        default:
          params = {}
      }
      return params
    }
  },
  watch: {
    parent: function () {
      this.setParentUsers()
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
button.btn-secondary {
    border-radius: 25px !important;
}
</style>
<style>
.user-select .custom__tag{
  margin-right: 25px;
}
.user-select .dropdown-menu {
  padding: 0;
  min-width: 25rem;
}
.user-select button.btn-secondary {
  padding: 0.375rem 0.65rem;
  border-radius: 25px !important;
}
.request-members .user-select button.btn-secondary {
  border: none;
  background: #fff;
}
.request-members .user-select button.btn-secondary:active {
  border: none;
}
.request-members .user-select .oi-plus {
  color: #6F6F6F;
}
.request-members .dropdown-menu.show .multiselect--active {
    min-height: 250px;
}
.user-select img {
  height: 25px;
  width: 25px;
  border-radius: 50%;
}
.btn-secondary:focus, .btn:focus {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/selectors/users/MultiUserSelector.vue